import consumerApi from "api/services/consumer-api";
import { DispensaryPromotion } from "custom-types/Promotions";
import logError from "utils/logError";

export const getDispensaryPromotions = async (
  dispensaryId: number,
): Promise<DispensaryPromotion[]> => {
  try {
    const {
      data: { data = [] },
    } = await consumerApi.get(`api/dispensaries/v1/${dispensaryId}/promotions`);

    return data;
  } catch (e) {
    logError(e.message, {
      functionName: "getDispensaryDeals",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return [];
  }
};
